import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]
  static values = { defaultLabel: String, field: String, key: String }

  change(e) {
    const button = e.currentTarget
    const field = document.querySelector(`#${this.fieldValue}`)
    field.value = button.getAttribute(`data-${this.keyValue}`)
    field.closest("form").requestSubmit()
    document.body.click()
    this.labelTarget.innerText = button.innerText.trim()
  }

  connect() {
    this.syncLabel()
  }

  syncLabel() {
    const value = document.querySelector(`#${this.fieldValue}`).value
    const button = value && document.querySelector(`[data-${this.keyValue}='${value}']`)
    if (button) {
      this.labelTarget.innerText = button.innerText.trim()
    } else if (this.hasDefaultLabelValue) {
      this.labelTarget.innerText = this.defaultLabelValue
    }
  }
}
